import { isMsTeams } from "PFCore/helpers/ms_teams";

import { useIsProPilotPermitted } from "./use_is_propilot_permitted";

export const useIsProPilotEnabled = (): boolean => {
  const isPermitted = useIsProPilotPermitted();
  return isPermitted && !isMsTeams();
};
